module.exports = __webpack_public_path__ + "media/xiaoman_04_摩天轮.bf894a30.wav";